import { FC, useMemo } from 'react';
import {
  FieldsRow,
  FieldsSection,
  FormNumericField,
  FormTextField,
} from '../../../../../../../../../../../../shared/components/form';
import { useTranslation } from 'react-i18next';
import { companyConfigService } from '../../../../../../../../../../../../shared/services/companyConfig/companyConfig.service';
import { C_Country } from '../../../../../../../../../../../../graphql/generatedModel';

export const DebtorAccount: FC = () => {
  const { t } = useTranslation();

  const countryId = useMemo(() => {
    return companyConfigService.getCachedConfigs()?.countryId;
  }, []);

  return (
    <FieldsSection
      titleProps={{ variant: 'body1' }}
      titleBoxSx={{ pt: 4 }}
      nomt
      title={t('customer.debtorAccount')}
    >
      <FieldsRow>
        <FormNumericField
          name='debtorAccount'
          width='192px'
          label={t('customer.debtorAccount')}
          precision={0}
        />
        <FormTextField
          slotProps={{ htmlInput: { maxLength: 32 } }}
          width='192px'
          label={t('customer.slipReference')}
          name='slipReferenceNo'
        />
        <FormTextField
          slotProps={{ htmlInput: { maxLength: 30 } }}
          name='incomeAccount'
          label={
            countryId === C_Country.CO1_SWITZERLAND
              ? t('customer.incomeAccount')
              : t('customer.revenueAccount')
          }
          width='192px'
        />
        <FormTextField
          slotProps={{ htmlInput: { maxLength: 30 } }}
          width='192px'
          name='costCenter'
          label={t('customer.costCenter')}
        />
      </FieldsRow>
    </FieldsSection>
  );
};
